/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Column_SpacesInputs */



/**
* | output |
* | --- |
* | "Spaces" |
*
* @param {Partner_Connectors_Column_SpacesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_column_spaces = /** @type {((inputs?: Partner_Connectors_Column_SpacesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Column_SpacesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Spaces")
	return /** @type {LocalizedString} */ ("Spaces")
});